// import React, { useState } from "react";
// import { Modal, Button } from "react-bootstrap";
// import "./History_Expert_Rate_Btn_Modal.css";
// import ReactStars from "react-rating-stars-component";
// // import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // import { faStar } from "@fortawesome/free-solid-svg-icons";
// import { render } from "react-dom";

// const History_Expert_Rate_Btn_Modal = ({
//   show,
//   handleClose,
//   modalName,
//   modalImg,
// }) => {
//   const [remark, setRemark] = useState("");

//   const ratingChanged = (newRating) => {
//     console.log(newRating);
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered className="rating-modal">
//       <Modal.Body className="p-0">
//         <div className="rating-card">
//           <div className="rating-content">
//             <div className="rating-thumb">
//               <img
//                 src={modalImg || "/assets/images/expert2.png"}
//                 alt="vendor"
//                 className="rating-img"
//               />
//             </div>
//             <div className="rating-body">
//               <div className="rating-info-row">
//                 <span className="rating-label">Name</span>
//                 <span className="rating-value">Shubham Mane</span>
//               </div>
//               <div className="rating-info-row">
//                 <span className="rating-label">Field</span>
//                 <span className="rating-value">Plumbing Repair</span>
//               </div>
//               <div className="rating-info-row">
//                 <span className="rating-label">Age</span>
//                 <span className="rating-value">28 years</span>
//               </div>

//               <div className="rating-info-row">
//                 <span className="rating-label">Experience</span>
//                 <span className="rating-value">6 Years</span>
//               </div>
//             </div>
//           </div>
//           <div className="rating-stars-container">
//             <div className="rating-stars-box">

//               <ReactStars
//                 count={5}
//                 onChange={ratingChanged}
//                 size={24}
//                 activeColor="#ffd700"
//               />
//             </div>
//           </div>
//           <div className="rating-remark-container px-3 mb-3">
//             <label className="rating-remark-label mb-1">Remarks:</label>
//             <textarea
//               className="form-control rating--textarea"
//               rows="2"
//               placeholder=""
//               value={remark}
//               onChange={(e) => setRemark(e.target.value)}
//             ></textarea>
//           </div>
//         </div>

//         <div className="text-center mt-2 pb-3">
//           <Button
//             className="rating-submit-btn"
//             onClick={() => {
//               console.log("Remark submitted:", remark);
//               handleClose();
//             }}
//           >
//             Submit
//           </Button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default History_Expert_Rate_Btn_Modal;

import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import "./History_Expert_Rate_Btn_Modal.css";
import Account_Created_Modal from "../../../login/account-created-modal/Account_Created_Modal";


const History_Expert_Rate_Btn_Modal = ({
  show,
  handleClose,
  modalName,
  modalImg,
}) => {
  const [remark, setRemark] = useState("");
  const [rating, setRating] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);

  const ratingChanged = (newRating) => {
    setRating(newRating);
  };

  const handleSubmit = () => {
    console.log("Remark submitted:", remark, "Rating:", rating);
  
    handleClose();

    setShowSuccess(true);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered className="rating-modal">
        <Modal.Body className="p-0">
          <div className="rating-card">
            <div className="rating-content">
              <div className="rating-thumb">
                <img
                  src={modalImg || "/assets/images/expert2.png"}
                  alt="vendor"
                  className="rating-img"
                />
              </div>
              <div className="rating-body">
                <div className="rating-info-row">
                  <span className="rating-label">Name</span>
                  <span className="rating-value">{modalName || "Shubham Mane"}</span>
                </div>
                <div className="rating-info-row">
                  <span className="rating-label">Field</span>
                  <span className="rating-value">Plumbing Repair</span>
                </div>
                <div className="rating-info-row">
                  <span className="rating-label">Age</span>
                  <span className="rating-value">28 years</span>
                </div>
                <div className="rating-info-row">
                  <span className="rating-label">Experience</span>
                  <span className="rating-value">6 Years</span>
                </div>
              </div>
            </div>
            <div className="rating-stars-container">
              <div className="rating-stars-box">
                <ReactStars
                  count={5}
                  onChange={ratingChanged}
                  size={24}
                  activeColor="#ffd700"
                />
              </div>
            </div>
            <div className="rating-remark-container px-3 mb-3">
              <label className="rating-remark-label mb-1">Remarks:</label>
              <textarea
                className="form-control rating--textarea"
                rows="2"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              ></textarea>
            </div>
          </div>

          <div className="text-center mt-2 pb-3">
            <Button className="rating-submit-btn" onClick={handleSubmit}>
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Account_Created_Modal
        showAccountModal={showSuccess}
        handleAccountModalClose={() => setShowSuccess(false)}
        text="Review Submitted Successfully!"
      />
    </>
  );
};

export default History_Expert_Rate_Btn_Modal;
